import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorService } from '../../../../../shared/services/error.service';
import { DireccionesService } from './direcciones.service';
import { Direccion } from './direcciones.interface';
import { PageHeaderComponent } from '../../../../../shared/components/common/page-header/page-header.component';
import { DeleteTrigger } from '../../../../../shared/components/ui/delete-trigger/delete-trigger';
import { SnackbarService } from '@shared/services/snackbar.service';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { LabelComponent } from '../../../../../shared/components/form/label/label.component';
import { DataTable, TableCellDirective, TableColumn } from '@shared/components/ui/list-components';
import { InputFieldComponent } from '@shared/components/form/input/input-field.component';
import { AppFormComponent } from '@shared/components/ui/list-components';

@Component({
  selector: 'app-direcciones',
  imports: [
    PageHeaderComponent,
    DeleteTrigger,
    ReactiveFormsModule,
    LabelComponent,
    DataTable,
    TableCellDirective,
    InputFieldComponent,
    AppFormComponent,
  ],
  templateUrl: './direcciones.html'
})
export class Direcciones implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private errorService = inject(ErrorService);
  private direccionesService = inject(DireccionesService);
  private snackbarService = inject(SnackbarService);
  private fB = inject(FormBuilder);

  direcciones: Direccion[] = [];
  loading = false;
  searchForm!: FormGroup;

  columns: TableColumn[] = [
    { key: 'direccion', header: 'Dirección' },
    { key: 'latitud', header: 'Latitud' },
    { key: 'longitud', header: 'Longitud' },
    { key: 'acciones', header: 'Acciones' },
  ];

  ngOnInit(): void {
    this.makeSearchForm();
    this.getDirecciones();
  }

  private makeSearchForm(): void {
    this.searchForm = this.fB.group({
      direccion: ['']
    });
  }

  getDirecciones(): void {
    this.loading = true;
    const params = this.searchForm.value.direccion ? { direccion: this.searchForm.value.direccion } : undefined;

    this.direccionesService.index(params).subscribe({
      next: (response) => {
        if (response.status) {
          this.direcciones = response.data;
        }
      },
      error: (error) => {
        this.errorService.handleError(error);
      }
    }).add(() => {
      this.loading = false;
    });
  }

  search(): void {
    this.getDirecciones();
  }

  clearSearch(): void {
    this.searchForm.reset();
    this.getDirecciones();
  }

  // create(): void {
  //   this.router.navigate(['new'], { relativeTo: this.route });
  // }

  edit(id: number): void {
    this.router.navigate(['./', id], { relativeTo: this.route });
  }

  delete(id: number): void {
    this.direccionesService.destroy(id).subscribe({
      next: (response) => {
        if (response.status) {
          this.snackbarService.showSnackBar('Dirección eliminada correctamente');
          this.getDirecciones();
        }
      },
      error: (error) => {
        this.errorService.handleError(error);
      }
    });
  }
}
